import React, { Component } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { Table } from 'reactstrap';
import * as actions from '../store/actions';
import { Link } from 'react-router-dom';
import { BASE_URL } from '../common/constants';
import Button from '@material-ui/core/Button';
import { Container, Row } from 'reactstrap';
import FormModal from '../components/FormModal';
import Form from '../components/Form';

const styles = theme => ({
  root: {
      width: '100%',
      maxWidth: 360,
      backgroundColor: theme.palette.background.paper,
    },
});

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    setTitle: (m) => dispatch(actions.base.setTitle(m)),
    updateMitartOptions: () => dispatch(actions.base.updateMitartOptions()),
  }
}


const mapStateToProps = (state) => {
  return {
    title: state.base.title,
    mitartOptions: state.base.mitartOptions,
    config: state.auth.config,
  }
}


class Mitgliedsarten extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      mitarten: false,
      mitart: false,
      modal: false,
    }
  }

  componentDidMount() {
    this.props.updateMitartOptions();
    axios.get(BASE_URL + 'mitgliedsart', this.props.config).then(res => {
      this.setState({ loading: false, mitarten: res.data, });
    });
    this.props.setTitle("Mitgliedsarten")
  }

  formChange = event => {
    let m = this.state.mitart
    m[event.target.name] = event.target.value;
    this.setState({ mitart: m });
  }

  closeModal = () => {
    this.setState({modal:false});
  }

  reload = () => {
    axios.get(BASE_URL + 'mitgliedsart', this.props.config).then(res => {
      this.setState({ loading: false, mitarten: res.data, });
    });
  }

  render() {
    return <Container><Row>
      { this.state.loading ? <h2>Daten werden geladen...</h2> :   <Row>
            <Button color="primary" onClick={ () => { this.setState({modal:true, mitart: {url: 'new'}}) } }>Neue Mitgliedsart anlegen</Button>
            <Table>
              <thead>
                <tr>
                  <th>id</th>
                  <th>art</th>
                  <th>bezeichnung</th>
                  <th>betrag</th>
                  <th>mitglieder</th>
                  <th>institutionen</th>
                </tr>
              </thead>
              <tbody>
                {this.state.mitarten.results.map((v,i) => (<tr key={v.id}>
                    <th scope="row" onClick={() => {this.setState({mitart: v, modal: true}) } }>{v.id}</th>
                    <td>{v.mitart}</td>
                    <td>{v.bezeichnung}</td>
                    <td>{v.anmerkung}</td>
                    <td>
                      <Link to={'/mitglieder/?key=mitgliedsart__mitart&value='+v.mitart}>{v.vereinsmitglied_count} ({v.vereinsmitglied_inactive_count})</Link>
                    </td>
                    <td>
                      <Link to={'/institutionen/?key=mitgliedsart__mitart&value='+v.mitart}>{v.institution_count} ({v.institution_inactive_count})</Link>
                    </td>
                  </tr>)
                )}
              </tbody>
            </Table>
        </Row>
      }
      </Row>
      <FormModal open={this.state.modal} title="Edit Adresse" handleClose={this.closeModal}>
        <Form values={this.state.mitart}
          options={this.props.mitartOptions}
          handleCancel={this.closeModal}
          postUrl={BASE_URL+'mitgliedsart/'}
          onChange={this.formChange} 
          postSave={this.reload} 
          handleDelete={this.reload} />          
      </FormModal>
    </Container>
  }
}

Mitgliedsarten.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(Mitgliedsarten))
